module.exports = __webpack_public_path__ + "bcbad7fdc68e41beeaca04a88980848e.MP3";